import { render, staticRenderFns } from "./ModalDetailCategory.vue?vue&type=template&id=79d225a9&scoped=true&"
import script from "./ModalDetailCategory.vue?vue&type=script&lang=js&"
export * from "./ModalDetailCategory.vue?vue&type=script&lang=js&"
import style0 from "../Komads.scss?vue&type=style&index=0&id=79d225a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d225a9",
  null
  
)

export default component.exports